module.exports = __webpack_public_path__ + "static/media/dc311.fdc0d838.jpg";